import React, { useState, useEffect } from "react";
import { Form, Input, Switch, Button,Modal} from "antd";
import { API_TXALERT2 } from "../../../config/config";
import axios from "axios";
import Swal from "sweetalert2";
import Cookies from "js-cookie";
import GroupAccess from "../../../helper/GroupAccess";
import TxalertMerchantListDropdown from "../Components/MerchantListDropdown";
import TxalertERProviderDropdown from "../Components/ERProviderDropdown";
import CatchError from "../../../helper/CatchError";

const Txalert_ERProviderLogin = (props) => {
    const { t, id,setId,isOpen,setIsOpen, fetchList } = props;
    const [details, setDetails] = useState(null);
    const [loading, setLoading] = useState(false);
    const [componentDisabled, setComponentDisabled] = useState(GroupAccess("SYSADMIN") ? false : true); //eslint-disable-line
    
   
    const layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };

    const initData = {
        merchant_name: "",
        gateway_name:"",
        express_resolve_gateway_id:"",
        merchant_id:"",
        username:"",
        authentication1:"",
        authentication2:"",
        authentication3:"",
        active: true
    };

    const handleOk = () => {
        setLoading(true);
        onFinish();
    };

   

    const [form] = Form.useForm();

    const handleCancel = () => {             
        setLoading(false);
        setId('');
        form.setFieldsValue(initData);
        setIsOpen(false);
        
    };

    const formValChange = (chgV, allV) => {      
          setDetails(allV);       
    };

    useEffect(() => {
     
        if(isOpen){
            if (typeof id != 'undefined') {
            
                getDetails();
            }else{
                setDetails(initData);
            }
        }
    }, [isOpen]); // eslint-disable-line

   
    const getDetails = async () => {

        const api_url = API_TXALERT2 + `/express_resolve_gateway/login/${id}`;
        await axios
            .get(api_url, { headers: { Authorization: Cookies.get("txalert_token") } })
            .then(({ data }) => {
                let recdata = data;
                setDetails(recdata);
                form.setFieldsValue({ ...recdata, activecheck: recdata.active === 1});
            })
            .catch((error) => console.log(error));
    };

    const onFinish = () => {
        let apiUrl = API_TXALERT2 ;
      
       if(id === 'undefined' || typeof id === 'undefined' || id === ''){
        apiUrl = apiUrl + "/express_resolve_gateway/login";
       }else{
        apiUrl = apiUrl + "/express_resolve_gateway/login/"+id;
       }
         axios
             .post(apiUrl, details,{ headers: { Authorization: "Bearer " + Cookies.get("txalert_token") }})
             .then(({ data }) => {
                 if (data.status === "OK") {
                     Swal.fire({
                         icon: "success",
                         title: data.msg,
                         showConfirmButton: false,
                         timer: 2000,
                         onClose: () => {
                             fetchList();
                         },
                     });
                     handleCancel();
                 } else {
                    CatchError(data);
                 }
             })
             .catch((error) => {
                console.log(error.response);
                 setLoading(false);
                CatchError(error);
             });
     };
    const isOkButtonProps = () => !details || !details.express_resolve_gateway_id || !details.api_url || loading;
    return(
        <>
            <Modal
                title={id !== undefined?t("contents.txalert_admin.form.view_er_login")+ ' id:'+id:t("contents.txalert_admin.form.add_er_login")}
                visible={isOpen}
                width={600}
                onCancel={handleCancel}
                onOk={handleOk}
                bodyStyle={{ paddingTop: '0px' }}
                footer={[
                    <Button key="back" onClick={() => handleCancel()}>
                        {t("contents.txalert_admin.form.cancel")}
                    </Button>,
                     GroupAccess("SYSADMIN") ? 
                    <Button key="submit" type="primary" loading={loading} disabled={isOkButtonProps()} onClick={() => handleOk()}>
                        {loading ? t("contents.txalert_admin.form.submitting") : t("contents.txalert_admin.form.submit")}
                    </Button>:'',
                ]}
            >
                <Form {...layout} form={form} name="merchant_detail" onValuesChange={formValChange}  >
                    <fieldset disabled={componentDisabled}>
                        <Form.Item name="express_resolve_gateway_id" label={t("contents.txalert_admin.form.gateway_name")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <TxalertERProviderDropdown />
                        </Form.Item>
                        <Form.Item name="merchant_id" label={t("contents.txalert_admin.form.merchant_name")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <TxalertMerchantListDropdown />
                        </Form.Item>
                        <Form.Item name="username" label={t("contents.txalert_admin.form.username")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item name="authentication1" label={t("contents.txalert_admin.form.authentication1")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item name="authentication2" label={t("contents.txalert_admin.form.authentication2")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item name="authentication3" label={t("contents.txalert_admin.form.authentication3")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item name="api_url" label={t("contents.txalert_admin.form.api_url")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item name="currency" label={t("contents.txalert_admin.form.currency")} rules={[{ required: true }]} style={{ marginBottom: ".5rem" }} >
                            <Input />
                        </Form.Item>
                        <Form.Item
                            key="active"
                            name="active"
                            label={t("contents.txalert_admin.form.isactive")}
                            valuePropName="checked"
                            style={{ marginBottom: ".5rem" }}
                        >
                            <Switch />
                        </Form.Item>
                                             
                    </fieldset>
                </Form>
            </Modal>
 
        </>
    );
};

export default Txalert_ERProviderLogin;
